import React from 'react';
import { getIn, useFormikContext } from 'formik';
import { ICheckboxInputProps, CheckboxInput } from '../CheckboxInput';

interface ICheckboxField extends Partial<ICheckboxInputProps> {
  // Sometimes the backend needs to store a boolean as a string.
  isStringValue?: boolean;
  name: string;
}

export const getValue = (value: any, isStringValue: boolean) => {
  if (!isStringValue) {
    return value;
  }

  return value ? 'TRUE' : 'FALSE';
};
//FYI: this simplifies integration with Formik. See README
export const CheckboxField: React.FC<ICheckboxField> = ({ name, isStringValue = false, ...rest }) => {
  const formik = useFormikContext();
  const onChange = (value: any) => {
    formik.setFieldTouched(name as never);

    const newValue = getValue(value, isStringValue);

    formik.setFieldValue(name as never, newValue);
    if (rest.onChange) {
      rest.onChange(newValue);
    }
  };
  const value = getIn(formik.values, name);
  const errorText =
    (!!formik.submitCount || !!getIn(formik.touched, name)) && !!getIn(formik.errors, name)
      ? getIn(formik.errors, name)
      : null;
  const usableValue = isStringValue ? value === 'TRUE' : value;
  return (
    <CheckboxInput
      {...rest}
      value={usableValue}
      onChange={onChange}
      errorText={errorText}
      data-test-id={rest['data-test-id'] || name}
    />
  );
};
